import { render, staticRenderFns } from "./BizCompanyList.vue?vue&type=template&id=8e3ab8b4&scoped=true"
import script from "./BizCompanyList.vue?vue&type=script&lang=js"
export * from "./BizCompanyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3ab8b4",
  null
  
)

export default component.exports